import { createBundle } from 'widget/Common';
import { routeAuthCodeMap } from 'utils/constants';

import PromoteHomeView from 'bundle-loader?lazy&name=PromoteHomeView!pages/Promote/PromoteHome/PromoteHomeView';
import SendBlessingsView from 'bundle-loader?lazy&name=SendBlessingsView!pages/Promote/PromoteHome/SendBlessings/SendBlessingsView';
import ShareSendBlessView from 'bundle-loader?lazy&name=ShareSendBlessView!pages/Promote/PromoteHome/ShareSendBless/ShareSendBlessView';
import MaterialCenterView from 'bundle-loader?lazy&name=MaterialCenterView!pages/Promote/MaterialCenter/MaterialCenterView';
import MaterialListSearchView from 'bundle-loader?lazy&name=MaterialListSearchView!pages/Promote/MaterialCenter/MaterialListSearch/MaterialListSearchView';
import MaterialDetailView from 'bundle-loader?lazy&name=MaterialDetailView!pages/Promote/MaterialCenter/MaterialDetail/MaterialDetailView';
import RecommendListView from 'bundle-loader?lazy&name=RecommendListView!pages/Promote/MaterialCenter/RecommendList/RecommendListView';
// ----- 我的名片 -----
import BusinessCardView from 'bundle-loader?lazy&name=BusinessCardView!pages/Promote/BusinessCard/BusinessCardView';
import BusinessCardViewNew from 'bundle-loader?lazy&name=BusinessCardView!pages/Promote/BusinessCard/BusinessCardViewNew';
import EditCardView from 'bundle-loader?lazy&name=EditCardView!pages/Promote/BusinessCard/EditCard/EditCardView';
import EditVideoView from 'bundle-loader?lazy&name=EditVideoView!pages/Promote/BusinessCard/EditVideo/EditVideoView';
import EditPromotionView from 'bundle-loader?lazy&name=EditPromotionView!pages/Promote/BusinessCard/EditPromotion/EditPromotionView';
import EditProductView from 'bundle-loader?lazy&name=EditProductView!pages/Promote/BusinessCard/EditProduct/EditProductView';
import AccoumulateArriveView from 'bundle-loader?lazy&name=AccoumulateArriveView!pages/Promote/BusinessCard/AccoumulateArrive/AccoumulateArriveView';
import LookGoodsHistoryView from 'bundle-loader?lazy&name=LookGoodsHistoryView!pages/Promote/BusinessCard/LookGoodsHistory/LookGoodsHistoryView';
import ProductListView from 'bundle-loader?lazy&name=LookGoodsHistoryView!pages/Promote/BusinessCard/ProductList/ProductListView';
// ----- 我的权益 -----
import EquityView from 'bundle-loader?lazy&name=EquityView!pages/Promote/Equity/EquityView';
import EquityVipView from 'bundle-loader?lazy&name=EquityVipView!pages/Promote/Equity/EquityVipView/index';
import EquityShareView from 'bundle-loader?lazy&name=EquityShareView!pages/Promote/Equity/EquityShare/EquityShareView';
import EquityCustomizeView from 'bundle-loader?lazy&name=EquityCustomizeView!pages/Promote/Equity/EquityCustomize/EquityCustomizeView';
import EquityImageTextView from 'bundle-loader?lazy&name=EquityImageTextView!pages/Promote/Equity/EquityImageText';
// ----- 业务大厅 -----
import BusinessHallView from 'bundle-loader?lazy&name=BusinessHallView!pages/Promote/BusinessHall/BusinessHallView';
import IdNumberVerification from 'bundle-loader?lazy&name=BusinessHallView!pages/Promote/BusinessHall/IdNumberVerification';
import NameRecordListView from 'bundle-loader?lazy&name=NameRecordListView!pages/Promote/BusinessHall/AlterName/RecordList/RecordListView';
import NameAlterDetailView from 'bundle-loader?lazy&name=NameDetailView!pages/Promote/BusinessHall/AlterName/Detail/DetailView';
import NameApplyView from 'bundle-loader?lazy&name=NameApplyView!pages/Promote/BusinessHall/AlterName/Apply/ApplyView';
import RelationRecordListView from 'bundle-loader?lazy&name=RelationRecordListView!pages/Promote/BusinessHall/AlterRelation/RecordList/RecordListView';
import RelationAlterDetailView from 'bundle-loader?lazy&name=RelationDetailView!pages/Promote/BusinessHall/AlterRelation/Detail/DetailView';
import RelationApplyView from 'bundle-loader?lazy&name=RelationApplyView!pages/Promote/BusinessHall/AlterRelation/Apply/ApplyView';
import MaterialRecordListView from 'bundle-loader?lazy&name=MaterialRecordListView!pages/Promote/BusinessHall/AlterMaterial/RecordList/RecordListView';
import MaterialAlterDetailView from 'bundle-loader?lazy&name=MaterialAlterDetailView!pages/Promote/BusinessHall/AlterMaterial/Detail/DetailView';
import MaterialApplyView from 'bundle-loader?lazy&name=MaterialApplyView!pages/Promote/BusinessHall/AlterMaterial/Apply/ApplyView';
import PunishRecordListView from 'bundle-loader?lazy&name=PunishRecordListView!pages/Promote/BusinessHall/Punish/RecordList/RecordListView';
import PunishDetailView from 'bundle-loader?lazy&name=PunishDetailView!pages/Promote/BusinessHall/Punish/Detail/DetailView';
import ReplaceApplyView from 'bundle-loader?lazy&name=ReplaceApplyView!pages/Promote/BusinessHall/ReplaceApply/ReplaceApplyView';
// import MaterialApplyView from 'bundle-loader?lazy&name=MaterialApplyView!pages/Promote/BusinessHall/AlterMaterial/Apply/ApplyView';
// ----- 业绩查询 -----
import AchievementView from 'bundle-loader?lazy&name=AchievementView!pages/Promote/Achievement/AchievementView';
import PersonalAchieveView from 'bundle-loader?lazy&name=PersonalAchieveView!pages/Promote/Achievement/PersonalAchieve/PersonalAchieveView';
import DeconvolutionQueryView from 'bundle-loader?lazy&name=PersonalAchieveView!pages/Promote/Achievement/DeconvolutionQuery/DeconvolutionQueryView';
import RegionManageView from 'bundle-loader?lazy&name=RegionManageView!pages/Promote/Achievement/RegionManage/RegionManageView';
import CommissionView from 'bundle-loader?lazy&name=CommissionView!pages/Promote/Achievement/Commission/CommissionView';
import CommissionDetailView from 'bundle-loader?lazy&name=CommissionDetailView!pages/Promote/Achievement/Commission/Detail/DetailView';
import RenewalQueryView from 'bundle-loader?lazy&name=RenewalQueryView!pages/Promote/Achievement/RenewalQuery/RenewalQueryView';
// ----- 日程管理 -----
import ScheduleView from 'bundle-loader?lazy&name=ScheduleView!pages/Promote/Schedule/ScheduleView';
import DetailedListView from 'bundle-loader?lazy&name=DetailedListView!pages/Promote/Schedule/DetailedList/DetailedListView';
import SearchView from 'bundle-loader?lazy&name=DetailedListView!pages/Promote/Schedule/DetailedList/Search/SearchView';
import NewAddView from 'bundle-loader?lazy&name=NewAddView!pages/Promote/Schedule/NewAdd/NewAddView';
import RemindCustomerView from 'bundle-loader?lazy&name=RemindCustomerView!pages/Promote/Schedule/NewAdd/RemindCustomer/RemindCustomerView';
import RemindTimeView from 'bundle-loader?lazy&name=RemindTimeView!pages/Promote/Schedule/NewAdd/RemindTime/RemindTimeView';
import RepeatView from 'bundle-loader?lazy&name=RepeatView!pages/Promote/Schedule/NewAdd/Repeat/RepeatView';
import TaskDetailView from 'bundle-loader?lazy&name=TaskDetailView!pages/Promote/Schedule/TaskDetail/TaskDetailView';
// ----- 线下活动 -----
import ActivityCenterView from 'bundle-loader?lazy&name=ActivityCenterView!pages/Promote/OfflineActivity/ActivityCenter/ActivityCenterView';
import PartakeActivityView from 'bundle-loader?lazy&name=PartakeActivityView!pages/Promote/OfflineActivity/ActivityCenter/PartakeActivity/PartakeActivityView';
import ActivitySearchView from 'bundle-loader?lazy&name=ActivitySearchView!pages/Promote/OfflineActivity/ActivityCenter/ActivitySearch/ActivitySearchView';
import EnterActivityView from 'bundle-loader?lazy&name=EnterActivityView!pages/Promote/OfflineActivity/EnterActivity/EnterActivityView';
import EnterDetailView from 'bundle-loader?lazy&name=EnterDetailView!pages/Promote/OfflineActivity/EnterActivity/EnterDetail/EnterDetailView';
import TransferDetailView from 'bundle-loader?lazy&name=TransferDetailView!pages/Promote/OfflineActivity/EnterActivity/TransferDetail/TransferDetailView';
import PreventionDetailView from 'bundle-loader?lazy&name=PreventionDetailView!pages/Promote/OfflineActivity/PreventionDetail/PreventionDetailView';
import SignInSuccessView from 'bundle-loader?lazy&name=SignInSuccessView!pages/Promote/OfflineActivity/SignInSuccess/SignInSuccessView';
import PayMentView from 'bundle-loader?lazy&name=payMentView!pages/Promote/OfflineActivity/PayMent/PayMentView';
import ActivityDetailView from 'bundle-loader?lazy&name=ActivityDetailView!pages/Promote/OfflineActivity/ActivityDetail/ActivityDetailView';
import SignInDetailView from 'bundle-loader?lazy&name=SignInDetailView!pages/Promote/OfflineActivity/SignIn/SignInDetail/SignInDetailView';
import SignSearchView from 'bundle-loader?lazy&name=SignSearchView!pages/Promote/OfflineActivity/SignSearch/SignSearchView';
import SignListView from 'bundle-loader?lazy&name=SignListView!pages/Promote/OfflineActivity/EnterActivity/SignList/SignListView';
import CheckInDetailView from 'bundle-loader?lazy&name=CheckInDetailView!pages/Promote/OfflineActivity/CheckIn/CheckInDetail/CheckInDetailView';
import CheckInSuccessView from 'bundle-loader?lazy&name=CheckInSuccessView!pages/Promote/OfflineActivity/CheckIn/CheckInSuccess/CheckInSuccessView';
import PictureListView from 'bundle-loader?lazy&name=PictureListView!pages/Promote/OfflineActivity/ActivityPicture/PictureList/PictureListView';
import UploadPictureView from 'bundle-loader?lazy&name=UploadPictureView!pages/Promote/OfflineActivity/ActivityPicture/UploadPicture/UploadPictureView';
import VideoPlayerView from 'bundle-loader?lazy&name=VideoPlayerView!pages/Promote/OfflineActivity/ActivityPicture/UploadPicture/VideoPlayerView';
import CheckPictureView from 'bundle-loader?lazy&name=CheckPictureView!pages/Promote/OfflineActivity/ActivityPicture/CheckPicture/CheckPictureView';
import WinningRecordView from 'bundle-loader?lazy&name=WinningRecordView!pages/Promote/WinningRecord/WinningRecordView';
import InviationView from 'bundle-loader?lazy&name=InviationView!pages/Promote/OfflineActivity/Invitation/inviationView';

// 营养师报名
import Guide from 'bundle-loader?lazy&name=DietitianRegister!pages/Promote/DietitianRegister/Guide/index';
import DietitianRegister from 'bundle-loader?lazy&name=DietitianRegister!pages/Promote/DietitianRegister/Register/index';
import AuditResult from 'bundle-loader?lazy&name=DietitianRegister!pages/Promote/DietitianRegister/AuditResult/index';
import FeeConfirm from 'bundle-loader?lazy&name=DietitianRegister!pages/Promote/DietitianRegister/FeeConfirm/index';
import ApplyFor from 'bundle-loader?lazy&name=DietitianRegister!pages/Promote/DietitianRegister/ApplyFor/index';
// ------- end -------

const RouterConfig = [
  {
    path: '/promote',
    title: '展业首页',
    component: () => {
      return createBundle(PromoteHomeView);
    }
  },
  {
    path: '/sendBlessings',
    title: '送祝福',
    component: () => {
      return createBundle(SendBlessingsView);
    }
  },
  {
    path: '/shareSendBless',
    title: '送祝福',
    component: () => {
      return createBundle(ShareSendBlessView);
    }
  },
  {
    path: '/promote/materialCenter',
    title: '素材中心',
    authCode: routeAuthCodeMap.EXPAND_MATERIAL,
    component: () => {
      return createBundle(MaterialCenterView);
    }
  },
  {
    path: '/promote/materialCenter/materialListSearch',
    title: '搜索素材',
    authCode: routeAuthCodeMap.EXPAND_MATERIAL,
    component: () => {
      return createBundle(MaterialListSearchView);
    }
  },
  {
    path: '/promote/materialCenter/materialDetail',
    title: '素材详情',
    authCode: routeAuthCodeMap.EXPAND_MATERIAL,
    component: () => {
      return createBundle(MaterialDetailView);
    }
  },
  {
    path: '/promote/materialCenter/RecommendList',
    title: '推荐素材',
    authCode: routeAuthCodeMap.EXPAND_MATERIAL,
    component: () => {
      return createBundle(RecommendListView);
    }
  },

  // ----- 我的名片 -----
  {
    path: '/promote/businessCard',
    title: '我的名片',
    component: () => {
      // return createBundle(SmartBusinessCard);
      return createBundle(BusinessCardView);
    }
  },
  {
    path: '/promote/businessCardNew',
    title: '我的名片新',
    component: () => {
      // return createBundle(SmartBusinessCard);
      return createBundle(BusinessCardViewNew);
    }
  },
  {
    path: '/promote/businessCard/editCard',
    title: '编辑名片',
    component: () => {
      return createBundle(EditCardView);
    }
  },
  {
    path: '/promote/businessCard/editVideo',
    title: '编辑视频',
    component: () => {
      return createBundle(EditVideoView);
    }
  },
  {
    path: '/promote/businessCard/editPromotion',
    title: '编辑活动',
    component: () => {
      return createBundle(EditPromotionView);
    }
  },
  {
    path: '/promoto/businessCard/editProduct',
    title: '编辑产品',
    component: () => {
      return createBundle(EditProductView);
    }
  }, // WinningRecordView
  {
    path: '/promoto/WinningRecordView',
    title: '中奖记录',
    component: () => {
      return createBundle(WinningRecordView);
    }
  }, // WinningRecordView
  {
    path: '/promoto/businessCard/accoumulateArrive',
    title: '累计访客',
    component: () => {
      return createBundle(AccoumulateArriveView);
    }
  },
  {
    path: '/promoto/businessCard/lookGoodsHistory',
    title: '商品浏览记录',
    component: () => {
      return createBundle(LookGoodsHistoryView);
    }
  },
  {
    path: '/promoto/businessCard/ProductList',
    title: '浏览记录',
    component: () => {
      return createBundle(ProductListView);
    }
  },
  // ----- 我的权益 -----
  {
    path: '/promote/equity',
    title: '我的权益',
    component: () => {
      return createBundle(EquityView);
    }
  },
  {
    path: '/promote/equityVip',
    title: 'VIP权益',
    component: () => {
      return createBundle(EquityVipView);
    }
  },
  {
    path: '/promote/equityImageText',
    title: '我的权益（图文模式）',
    component: () => {
      return createBundle(EquityImageTextView);
    }
  },
  {
    path: '/promote/equity/share',
    title: '我的权益',
    component: () => {
      return createBundle(EquityShareView);
    }
  },
  {
    path: '/promote/equity/customize',
    title: '我的权益',
    component: () => {
      return createBundle(EquityCustomizeView);
    }
  },
  // ----- 服务大厅 -----
  {
    path: '/promote/businessHall',
    title: '服务大厅',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(BusinessHallView);
    }
  },
  {
    path: '/promote/businessHall/idNumberVerification',
    title: '证件号审核',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(IdNumberVerification);
    }
  },
  {
    path: '/promote/businessHall/alterName/recordList',
    title: '更名记录',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(NameRecordListView);
    }
  },
  {
    path: '/promote/businessHall/alterName/detail/:id',
    title: '更名详情',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(NameAlterDetailView);
    }
  },
  {
    path: '/promote/businessHall/alterName/apply',
    title: '申请更名',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(NameApplyView);
    }
  },
  {
    path: '/promote/businessHall/alterRelation/recordList',
    title: '更改关系记录',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(RelationRecordListView);
    }
  },
  {
    path: '/promote/businessHall/alterRelation/detail/:id',
    title: '更改关系详情',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(RelationAlterDetailView);
    }
  },
  {
    path: '/promote/businessHall/alterRelation/apply',
    title: '申请更改关系',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(RelationApplyView);
    }
  },
  {
    path: '/promote/businessHall/alterMaterial/recordList',
    title: '更改资料记录',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(MaterialRecordListView);
    }
  },
  {
    path: '/promote/businessHall/alterMaterial/detail/:id',
    title: '更改资料详情',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(MaterialAlterDetailView);
    }
  },
  {
    path: '/promote/businessHall/alterMaterial/apply',
    title: '申请更改资料',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(MaterialApplyView);
    }
  },
  {
    path: '/promote/businessHall/punish/recordList',
    title: '违规处罚通知',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(PunishRecordListView);
    }
  },
  {
    path: '/promote/businessHall/punish/detail/:id',
    title: '违规处罚通知',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(PunishDetailView);
    }
  },
  {
    path: '/promote/businessHall/replaceApply',
    title: '违规处罚通知',
    authCode: routeAuthCodeMap.EXPAND_SERVICE,
    component: () => {
      return createBundle(ReplaceApplyView);
    }
  },
  // ----- 业绩查询 -----
  {
    path: '/promote/achievement',
    title: '业绩查询',
    authCode: routeAuthCodeMap.EXPAND_MARK,
    component: () => {
      return createBundle(AchievementView);
    }
  },
  {
    path: '/promote/achievement/region',
    title: '区域管理',
    authCode: routeAuthCodeMap.EXPAND_MARK,
    component: () => {
      return createBundle(RegionManageView);
    }
  },
  {
    path: '/promote/achievement/personal',
    title: '个人业绩',
    authCode: routeAuthCodeMap.EXPAND_MARK,
    component: () => {
      return createBundle(PersonalAchieveView);
    }
  },
  {
    path: '/promote/achievement/deconvolution',
    title: '复消查询',
    authCode: routeAuthCodeMap.EXPAND_MARK,
    component: () => {
      return createBundle(DeconvolutionQueryView);
    }
  },
  {
    path: '/promote/achievement/commission',
    title: '我的销售费',
    authCode: routeAuthCodeMap.EXPAND_MARK,
    component: () => {
      return createBundle(CommissionView);
    }
  },
  {
    path: '/promote/achievement/commission/detail',
    title: '销售费详情',
    authCode: routeAuthCodeMap.EXPAND_MARK,
    component: () => {
      return createBundle(CommissionDetailView);
    }
  },
  {
    path: '/promote/achievement/renewal',
    title: '续约查询',
    authCode: routeAuthCodeMap.EXPAND_MARK,
    component: () => {
      return createBundle(RenewalQueryView);
    }
  },
  // ----- 日程管理 -----
  {
    path: '/promote/schedule',
    title: '日程管理',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(ScheduleView);
    }
  },
  {
    path: '/promote/schedule/detailedList',
    title: '日程清单',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(DetailedListView);
    }
  },
  {
    path: '/promote/schedule/edit/:id/:subId',
    title: '编辑日程',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(NewAddView);
    }
  },
  {
    path: '/promote/schedule/newAdd',
    title: '新建日程',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(NewAddView);
    }
  },
  {
    path: '/promote/schedule/taskDetail/:id',
    title: '任务详情',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(TaskDetailView);
    }
  },
  {
    path: '/promote/schedule/DetailedList/search',
    title: '搜索',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(SearchView);
    }
  },
  {
    path: '/promote/schedule/newAdd/remindCustomer',
    title: '选择提醒客户',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(RemindCustomerView);
    }
  },
  {
    path: '/promote/schedule/newAdd/remindTime',
    title: '选择提醒时间',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(RemindTimeView);
    }
  },
  {
    path: '/promote/schedule/newAdd/repeat',
    title: '重复',
    authCode: routeAuthCodeMap.EXPAND_SCHEDULE,
    component: () => {
      return createBundle(RepeatView);
    }
  },
  // ------线下活动
  {
    path: '/promote/offlineActivity/activityCenter',
    title: '活动中心',
    component: () => {
      return createBundle(ActivityCenterView);
    }
  },
  {
    path: '/promote/offlineActivity/partakeActivity',
    title: '我参与的列表',
    component: () => {
      return createBundle(PartakeActivityView);
    }
  },
  {
    path: '/promote/offlineActivity/activitySearch',
    title: '活动搜索',
    component: () => {
      return createBundle(ActivitySearchView);
    }
  },
  {
    path: '/promote/offlineActivity/enterAcitity',
    title: '活动报名中间页',
    component: () => {
      return createBundle(EnterActivityView);
    }
  },
  {
    path: '/promote/offlineActivity/enterDetail',
    title: '报名信息页',
    component: () => {
      return createBundle(EnterDetailView);
    }
  },
  {
    path: '/promote/offlineActivity/transferDetail',
    title: '转让信息页',
    component: () => {
      return createBundle(TransferDetailView);
    }
  },
  {
    path: '/promote/offlineActivity/prevention',
    title: '防疫信息页',
    component: () => {
      return createBundle(PreventionDetailView);
    }
  },
  {
    path: '/promote/offlineActivity/signInSuccess',
    title: '签到成功',
    component: () => {
      return createBundle(SignInSuccessView);
    }
  },
  {
    path: '/promote/offlineActivity/payMent',
    title: '报名成功-支付成功',
    component: () => {
      return createBundle(PayMentView);
    }
  },
  {
    path: '/promote/offlineActivity/activityDetail',
    title: '活动详情页',
    component: () => {
      return createBundle(ActivityDetailView);
    }
  },
  {
    path: '/promote/offlineActivity/signInDetail',
    title: '报名详情页',
    component: () => {
      return createBundle(SignInDetailView);
    }
  },
  {
    path: '/promote/offlineActivity/signSearch',
    title: '报名信息搜索',
    component: () => {
      return createBundle(SignSearchView);
    }
  },
  {
    path: '/promote/offlineActivity/signList',
    title: '报名搜索-未完成报名前',
    component: () => {
      return createBundle(SignListView);
    }
  },
  {
    path: '/promote/offlineActivity/checkInDetail',
    title: '签到页面',
    component: () => {
      return createBundle(CheckInDetailView);
    }
  },
  {
    path: '/promote/offlineActivity/checkInSuccess',
    title: '签到成功页面',
    component: () => {
      return createBundle(CheckInSuccessView);
    }
  },
  {
    path: '/promote/offlineActivity/pictureList',
    title: '精彩瞬间列表',
    component: () => {
      return createBundle(PictureListView);
    }
  },
  {
    path: '/promote/offlineActivity/uploadPicture',
    title: '上传照片',
    component: () => {
      return createBundle(UploadPictureView);
    }
  },
  {
    path: '/promote/offlineActivity/uploadPicture/videoPlayer',
    title: '视频播放',
    component: () => {
      return createBundle(VideoPlayerView);
    }
  },
  {
    path: '/promote/offlineActivity/checkPicture',
    title: '查看照片',
    component: () => {
      return createBundle(CheckPictureView);
    }
  },
  {
    path: '/promote/offlineActivity/Inviation',
    title: '邀请函',
    component: () => {
      return createBundle(InviationView);
    }
  },
  {
    path: '/promote/dietitianRegister/guide',
    title: '慢病管理师指南',
    component: () => {
      return createBundle(Guide);
    }
  },
  {
    path: '/promote/dietitianRegister/register',
    title: '报名填写',
    component: () => {
      return createBundle(DietitianRegister);
    }
  },
  {
    path: '/promote/dietitianRegister/auditResult',
    title: '报名审核信息',
    component: () => {
      return createBundle(AuditResult);
    }
  },
  {
    path: '/promote/dietitianRegister/feeConfirm',
    title: '报名费',
    component: () => {
      return createBundle(FeeConfirm);
    }
  },
  {
    path: '/promote/dietitianRegister/applyFor',
    title: '慢病报考',
    component: () => {
      return createBundle(ApplyFor);
    }
  }

  // ------- end -------
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Promote/RouterConfig.js